import DgMode from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgMode.install = function (Vue) {
  Vue.component(DgMode.name, DgMode)
}
export default DgMode

export { DgMode }